<template>
  <video-player  class="video-player vjs-custom-skin"
                 ref="videoPlayer"
                 :options="playerOptions"
                 :playsinline="true"
                 customEventName="customstatechangedeventname"
                 @play="onPlayerPlay($event)"
                 @pause="onPlayerPause($event)"
                 @statechanged="playerStateChanged($event)"
                 @ready="playerReadied"
                 @error="error($event)">

                <!--@ended="onPlayerEnded($event)"-->
                <!--@waiting="onPlayerWaiting($event)"-->
                <!--@playing="onPlayerPlaying($event)"-->
                <!--@loadeddata="onPlayerLoadeddata($event)"-->
                <!--@timeupdate="onPlayerTimeupdate($event)"-->
                <!--@canplay="onPlayerCanplay($event)"-->
                <!--@canplaythrough="onPlayerCanplaythrough($event)"-->
  </video-player>
</template>

<script>
  import 'video.js/dist/video-js.css'
  import '@/assets/css/custom-theme.css';
  import { videoPlayer } from 'vue-video-player'

  export default {
    name:'player',
    components: {
      videoPlayer
    },
    props:{
      option:{
        type:Object,
        default(){
          return{

          }
        }
      },
      Height:{
        type:Number,
        default:474
      },
      muted:{
        type:Boolean,
        default:false
      },
      autoplay:{
        type: Boolean,
        default:false
      },
    },
    data() {
      return {
        playerOptions: {
          // videojs options
          muted: this.muted,
          language: 'en',
          height: this.Height,
          sources: [{
            type: "video/mp4",
            src: this.option.src
          }],
          poster: this.option.poster,
          autoplay: this.autoplay
        }
      }
    },
    watch: {
      option(n,o) {
        if(n.src != o.src){
          let myPlayer = this.$refs.videoPlayer.player;
          myPlayer.src(n.src); //根据userType的不同展示不同的视频地址

          // console.log(myPlayer.src())
          // console.log(myPlayer)
        }
      }
    },
    methods:{
      error(player){
        // console.log('error play!', player);
        // console.log(player.src());
        // player.src(player.src());

        // player.load(player.src());
      },
      // listen event
      onPlayerPlay(player) {
        // console.log('player play!', player)
        this.$emit("pause",player)
      },
      onPlayerPause(player) {
        // console.log('player pause!', player)
      },
      // ...player event

      // or listen state event
      playerStateChanged(playerCurrentState) {
        console.log('player current update state', playerCurrentState)
      },

      // player is ready
      playerReadied(player) {
        console.log('the player is readied', player)
        // you can use it to do something...
        // player.[methods]
        // player.load();
      }
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>



// WEBPACK FOOTER //
// Player.vue?fd58ebf2